import { ClipLoaderSpinner } from 'components/spinner/ClipLoaderSpinner'
import { FadeLoaderSpinner } from 'components/spinner/FadeLoaderSpinner copy'
import React, { PropsWithChildren } from 'react'

interface ScriptLoadingSkeletonProps {
  messageIndex: number
  loadingMessages: string[]
}

export const ScriptLoadingSkeleton = ({
  loadingMessages,
  messageIndex,
}: PropsWithChildren<ScriptLoadingSkeletonProps>) => {
  return (
    <div className=" absolute w-full h-full ml-4 mt-2">
      <div className="space-y-2">
        <button
          className="px-4 py-1 rounded-full bg-[#E0EEFF] flex gap-1 items-center"
          type="button"
        >
          <ClipLoaderSpinner color="black" size={20} />{' '}
          <span>{loadingMessages[messageIndex]}</span>
        </button>
        <div className="relative overflow-hidden  h-5 bg-gray-200 w-7/12">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/60 to-transparent animate-skeleton" />
        </div>
        <div className="relative overflow-hidden   h-5 bg-gray-200 w-9/12">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/60 to-transparent animate-skeleton" />
        </div>
        <div className="relative overflow-hidden   h-5 bg-gray-200 w-8/12">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/60 to-transparent animate-skeleton" />
        </div>
        <div className="relative overflow-hidden   h-5 bg-gray-200 w-5/12">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/60 to-transparent animate-skeleton" />
        </div>
        <p>대본 생성에 몇 분 정도 소요될 수 있습니다.</p>
      </div>
    </div>
  )
}
